// General
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
// Services
import {
  useLazyGetProfilePwaQuery,
  useLazyGetProfileQuery,
  useLazyGetUserAioQuery,
  useLazyGetPrivateCallFreeMinutesQuery,
  useLazyGetAioQuery,
  useLazyGetLevellingTasksQuery,
  useLazyGetLivestreamingContestListQuery,
  useLazyGetPrivateCallContestListQuery,
  useInitiateEmailVerificationMutation,
  useLazyGetNotificationsCountQuery,
  useLazyGetJourneyQuery,
} from "../../../../services/data.service";
import { sessionService } from "../../../../services/session.service";
import { API_CONFIG_HEADERS } from "../../../../const/apiConst";
// Static Data
import routeConst from "../../../../const/routeConst";
import userConst from "../../../../const/userConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  // Timer Functions
  setDailyCheckInTimer,
  updateDailyCheckInTimer,
  resetDailyCheckInTimer,

  // Interval Functions
  updateDailyCheckInInterval,
  clearDailyCheckInInterval,
  updateVpnBlockInfo,
} from "../../../../redux/store/publicStore";
import {
  updateIsDaddy,
  updateIsMommy,
  updateIsSugarbaby,
  updateIsSugarbabyMale,
  updateMembershipType,

  // Utility Functions
  updateIsMissingDetails,
} from "../../../../redux/store/userStore";
import {
  updateLivestreamingContestId,
  updateLivestreamingContestPkId,
  updateLivestreamingContestPkList,
  updatePrivateCallContestId,
} from "../../../../redux/store/leaderboardStore";
import { updateOwnPrivateCallEnable } from "../../../../redux/store/inboxStore";
import {
  // Email Verification Functions
  setEmailVerificationTimer,
  updateEmailVerificationDisplay,
  updateEmailVerificationRequired,

  // Mobile Verification Functions
  updateMobileVerificationDisplay,
  updateMobileVerificationRequired,
} from "../../../../redux/store/verificationStore";
import {
  updateNotificationCount,
  updateNotificationCountLoaded,
  updateShowNotificationBadge,
} from "../../../../redux/store/notificationStore";
import { updateGlobalPusherSubscribe } from "../../../../redux/store/pusherStore";
import {
  updateJourneyNavigationPassthrough,
  updateJourneyDataPassthrough,
  updateLastLocation,
  updateVerificationDataPassthrough,
  updateVerificationNavigatePassthrough,
  updateSkippableJourney,
} from "../../../../redux/store/registrationStore";
import {
  updateProfileCompletionPercentage,
  updateProfileRequirementPopup,
} from "../../../../redux/store/profileStore";
import { updateEmail } from "../../../../redux/store/signupStore";
import { updateIsKommunicateInitialized } from "../../../../redux/store/appStore";
import {
  updateDailyCheckInDialog,
  updateVpnBlockDialog,
} from "../../../../redux/store/dialogStore";
import { updateErrorToast } from "../../../../redux/store/toastStore";
// Sentry
import * as Sentry from "@sentry/react";
// i18next
import { useTranslation } from "react-i18next";
// Moment
import moment from "moment";
// Kommunicate
import Kommunicate from "@kommunicate/kommunicate-chatbot-plugin";
// Custom Hooks
import useCustomNavigate from "../../custom-hooks/useCustomNavigate-hook";

const ApiMounted = () => {
  // API variables
  const [
    getProfile,
    {
      data: getProfileData,
      error: getProfileErrorData,
      isFetching: getProfileFetching,
      isLoading: getProfileLoading,
      isSuccess: getProfileSuccess,
      isError: getProfileError,
    },
  ] = useLazyGetProfileQuery();
  const [
    getProfilePwa,
    {
      data: getProfilePwaData,
      error: getProfilePwaErrorData,
      isFetching: getProfilePwaFetching,
      isLoading: getProfilePwaLoading,
      isSuccess: getProfilePwaSuccess,
      isError: getProfilePwaError,
    },
  ] = useLazyGetProfilePwaQuery();
  const [
    getUserAio,
    {
      data: getUserAioData,
      error: getUserAioErrorData,
      isFetching: getUserAioFetching,
      isLoading: getUserAioLoading,
      isSuccess: getUserAioSuccess,
      isError: getUserAioError,
    },
  ] = useLazyGetUserAioQuery();
  const [
    getPrivateCallFreeMinutes,
    {
      data: getPrivateCallFreeMinutesData,
      error: getPrivateCallFreeMinutesErrorData,
      isFetching: getPrivateCallFreeMinutesFetching,
      isLoading: getPrivateCallFreeMinutesLoading,
      isSuccess: getPrivateCallFreeMinutesSuccess,
      isError: getPrivateCallFreeMinutesError,
    },
  ] = useLazyGetPrivateCallFreeMinutesQuery();
  const [
    getAio,
    {
      data: getAioData,
      error: getAioErrorData,
      isFetching: getAioFetching,
      isLoading: getAioLoading,
      isSuccess: getAioSuccess,
      isError: getAioError,
    },
  ] = useLazyGetAioQuery();
  const [
    getLevellingTasks,
    {
      data: getLevellingTasksData,
      error: getLevellingTasksErrorData,
      isFetching: getLevellingTasksFetching,
      isLoading: getLevellingTasksLoading,
      isSuccess: getLevellingTasksSuccess,
      isError: getLevellingTasksError,
    },
  ] = useLazyGetLevellingTasksQuery();
  const [
    getLivestreamingContestList,
    {
      data: getLivestreamingContestListData,
      error: getLivestreamingContestListErrorData,
      isFetching: getLivestreamingContestListFetching,
      isLoading: getLivestreamingContestListLoading,
      isSuccess: getLivestreamingContestListSuccess,
      isError: getLivestreamingContestListError,
    },
  ] = useLazyGetLivestreamingContestListQuery();
  const [
    getPrivateCallContestList,
    {
      data: getPrivateCallContestListData,
      error: getPrivateCallContestListErrorData,
      isFetching: getPrivateCallContestListFetching,
      isLoading: getPrivateCallContestListLoading,
      isSuccess: getPrivateCallContestListSuccess,
      isError: getPrivateCallContestListError,
    },
  ] = useLazyGetPrivateCallContestListQuery();
  const [
    initiateEmailVerification,
    {
      data: initiateEmailVerificationData,
      error: initiateEmailVerificationErrorData,
      isLoading: initiateEmailVerificationLoading,
      isSuccess: initiateEmailVerificationSuccess,
      isError: initiateEmailVerificationError,
    },
  ] = useInitiateEmailVerificationMutation();
  const [
    getNotificationsCount,
    {
      data: getNotificationsCountData,
      error: getNotificationsCountErrorData,
      isFetching: getNotificationsCountFetching,
      isLoading: getNotificationsCountLoading,
      isSuccess: getNotificationsCountSuccess,
      isError: getNotificationsCountError,
    },
  ] = useLazyGetNotificationsCountQuery();
  const [
    getJourney,
    {
      data: getJourneyData,
      error: getJourneyErrorData,
      isFetching: getJourneyFetching,
      isLoading: getJourneyLoading,
      isSuccess: getJourneySuccess,
      isError: getJourneyError,
    },
  ] = useLazyGetJourneyQuery();

  // General variables
  const [hasLoaded, setHasLoaded] = useState(false);

  // Redux variables
  const isLoggedIn = useSelector((state) => state.public.isLoggedIn);
  const dailyCheckInInterval = useSelector(
    (state) => state.public.dailyCheckInInterval
  );
  const dailyCheckInTimer = useSelector(
    (state) => state.public.dailyCheckInTimer
  );
  const dispatch = useDispatch();

  // Router variables
  const location = useLocation();

  // i18next variables
  const { i18n } = useTranslation();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();

  // Lifecycle | Mounted
  useEffect(() => {
    // Add sb-development header for development environment
    if (process.env["REACT_APP_ENVIRONMENT"] === "development") {
      API_CONFIG_HEADERS.COM_HEADERS["sb-development"] = 1;
      API_CONFIG_HEADERS.COM_HEADERS_FORM_DATA["sb-development"] = 1;
    }

    if (window.matchMedia("(display-mode: standalone)").matches) {
      API_CONFIG_HEADERS.SB_API_HEADERS["display-mode"] = "standalone";
      API_CONFIG_HEADERS.COM_HEADERS["display-mode"] = "standalone";
      API_CONFIG_HEADERS.SPI_HEADERS["display-mode"] = "standalone";
      API_CONFIG_HEADERS.SB_API_HEADERS_FORM_DATA["display-mode"] =
        "standalone";
      API_CONFIG_HEADERS.COM_HEADERS_FORM_DATA["display-mode"] = "standalone";
    }

    getAio();

    document.addEventListener("visibilitychange", generalVisibilityChange);
  }, []);

  // Lifecycle | Check for update | isLoggedIn
  useEffect(() => {
    if (isLoggedIn) {
      getProfilePwa(null, false);
      getProfile("?mounted=true", false);
      getUserAio("?mounted=true", false);
      getPrivateCallFreeMinutes(); // Not used
      // getLevellingTasks(); // Moved to User AIO
      getLivestreamingContestList();
      getPrivateCallContestList();
      getNotificationsCount();

      document.addEventListener("visibilitychange", loggedInVisibilityChange);
    } else {
      setHasLoaded(false);
      document.removeEventListener(
        "visibilitychange",
        loggedInVisibilityChange
      );
    }

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener(
        "visibilitychange",
        loggedInVisibilityChange
      );
    };
  }, [isLoggedIn]);

  // Lifecycle | Check for update | AIO API Response
  useEffect(() => {
    if (getAioFetching || getAioLoading) {
    } else if (getAioSuccess) {
      if (getAioData?.status === 0) {
        // Close VPN Block Dialog
        dispatch(updateVpnBlockDialog(false));
      } else if (
        getAioData?.success === "false" &&
        getAioData?.code === "403"
      ) {
        // Open VPN Block Dialog
        dispatch(updateVpnBlockInfo(getAioData?.message?.pwa));
        dispatch(updateVpnBlockDialog(true));
      }
    } else if (getAioError) {
      if (getAioErrorData?.status === 401) {
        onNavigate(routeConst.logout.path);
      }
    }
  }, [getAioFetching, getAioLoading, getAioSuccess, getAioError]);

  // Lifecycle | Check for update | Profile PWA API Response
  useEffect(() => {
    if (getProfilePwaFetching || getProfilePwaLoading) {
    } else if (getProfilePwaSuccess) {
      if (getProfilePwaData?.status === 0) {
        dispatch(
          updateMembershipType(
            getProfilePwaData?.payload?.message?.profile?.membershiptype
          )
        );
      }
    } else if (getProfilePwaError) {
    }
  }, [
    getProfilePwaFetching,
    getProfilePwaLoading,
    getProfilePwaSuccess,
    getProfilePwaError,
  ]);

  // Lifecycle | Check for update | Profile API Response
  useEffect(() => {
    if (getProfileFetching || getProfileLoading) {
    } else if (getProfileSuccess) {
      if (getProfileData?.status === 0) {
        dispatch(updateGlobalPusherSubscribe({}));

        dispatch(
          updateIsDaddy(
            getProfileData?.data?.role === userConst.userRole.sugardaddy ||
              getProfileData?.data?.role === userConst.userRole.sugarmommy
          )
        ); // TODO: Changing to individual role instead of merged sugardaddy and sugarmommy
        dispatch(
          updateIsMommy(
            getProfileData?.data?.role === userConst.userRole.sugarmommy
          )
        );
        dispatch(
          updateIsSugarbaby(
            getProfileData?.data?.role === userConst.userRole.sugarbaby
          )
        );
        dispatch(
          updateIsSugarbabyMale(
            getProfileData?.data?.role === userConst.userRole.maleSugarbaby
          )
        );
        // dispatch(updateCalleeId(getProfileData?.data?.id)); // TBA

        // Update Verification Passthrough
        const verificationObj = {
          email: {
            verified: getProfileData?.data?.verifications?.email?.verified,
            verification_display:
              getProfileData?.data?.verifications?.email?.verification_display,
            verification_required:
              getProfileData?.data?.verifications?.email?.verification_required,
          },
          mobile: {
            verified: getProfileData?.data?.verifications?.mobile?.verified,
            verification_display:
              getProfileData?.data?.verifications?.mobile?.verification_display,
            verification_required:
              getProfileData?.data?.verifications?.mobile
                ?.verification_required,
          },
          facial: {
            verified: getProfileData?.data?.verifications?.facial?.verified,
            verification_display:
              getProfileData?.data?.verifications?.facial?.verification_display,
            verification_required:
              getProfileData?.data?.verifications?.facial
                ?.verification_required,
          },
          vp3: {
            verified: getProfileData?.data?.vp3?.verified,
            verification_display: true,
            verification_required:
              getProfileData?.data?.verifications?.facial
                ?.verification_required, //getProfileData?.data?.vp3?.required,
          },
        };
        dispatch(updateVerificationDataPassthrough(verificationObj));
        dispatch(updateEmail(getProfileData?.data?.email));

        // Sentry
        Sentry.setUser({ id: getProfileData?.data?.id_int });

        // Initialize Insider
        const userData = {
          user_id: getProfileData?.data?.id_int,
          email: getProfileData?.data?.email,
          username: getProfileData?.data?.username,
          role: getProfileData?.data?.role,
          is_premium:
            getProfileData?.data?.membership_type ===
              userConst.membershipType.premium ||
            getProfileData?.data?.membership_type ===
              userConst.membershipType.freePremium ||
            getProfileData?.data?.membership_type ===
              userConst.membershipType.diamond,
          signup_date: getProfileData?.data?.activity?.joined_timestamp,
        };
        window.dataLayer.push(userData);

        if (!hasLoaded) {
          // Set hasLoaded to only run this function once
          setHasLoaded(true);

          if (
            (verificationObj?.email?.verification_display &&
              !verificationObj?.email?.verified) ||
            (verificationObj?.mobile?.verification_display &&
              !verificationObj?.mobile?.verified)
          ) {
            dispatch(updateVerificationNavigatePassthrough());
          } else if (getProfileData?.data?.signup_journey_required) {
            // Check if Journey is required
            getJourney("mounted", false);
          } else if (
            verificationObj?.facial?.verification_required &&
            (!verificationObj?.facial?.verified ||
              !verificationObj?.vp3?.verified)
          ) {
            // return;
            if (process.env["REACT_APP_ENVIRONMENT"] === "development") {
              // Force Facial Verification
              onNavigate(
                routeConst.verify.sugarbookVerified.onboarding.path,
                false
              );
            } else {
              // Force Facial Verification
              onNavigate(
                routeConst.verify.sugarbookVerified.onboarding.path,
                true
              );
            }
          }

          dispatch(
            updateProfileCompletionPercentage(
              getProfileData?.data?.profile_progress?.summary?.progress
            )
          );
          dispatch(
            updateProfileRequirementPopup(
              getProfileData?.data?.profile_progress?.summary?.requirement
            )
          );

          // Save the state of email and mobile verification required
          // Used for checking if email and mobile verification is skippable
          // dispatch(
          //   updateEmailVerificationDisplay(
          //     getProfileData?.data?.user?.verification?.email
          //       ?.verification_display
          //   )
          // );
          // dispatch(
          //   updateEmailVerificationRequired(
          //     getProfileData?.data?.user?.verification?.email
          //       ?.verification_required
          //   )
          // );
          // dispatch(
          //   updateMobileVerificationDisplay(
          //     getProfileData?.data?.user?.verification?.mobile
          //       ?.verification_display
          //   )
          // );
          // dispatch(
          //   updateMobileVerificationRequired(
          //     getProfileData?.data?.user?.verification?.mobile
          //       ?.verification_required
          //   )
          // );
          // dispatch(
          //   updateIsMissingDetails(
          //     !getProfileData?.data?.username &&
          //       !getProfileData?.data?.profile_details_approval?.username
          //         ?.new_content
          //   )
          // );

          // if (
          //   !getProfileData?.data?.verifications?.email?.verified &&
          //   getProfileData?.data?.verifications?.email?.verification_display
          // ) {
          //   initiateEmailVerification();
          // } else if (
          //   !getProfileData?.data?.verifications?.mobile?.verified &&
          //   getProfileData?.data?.verifications?.mobile?.verification_display
          // ) {
          //   onNavigate(routeConst.phoneAuthentication.altPath);
          // } else if (
          //   !getProfileData?.data?.username &&
          //   !getProfileData?.data?.profile_details_approval?.username
          //     ?.new_content
          // ) {
          //   onNavigate(routeConst.missingDetails.path);
          // }
        }
      }
    } else if (getProfileError) {
      if (getProfileErrorData?.status === 401) {
        onNavigate(routeConst.logout.path);
      } else {
        // Send to Sentry
        Sentry.captureMessage(
          "API Mounted /me Error: " + JSON.stringify(getProfileErrorData)
        );
      }
    }
  }, [
    getProfileFetching,
    getProfileLoading,
    getProfileSuccess,
    getProfileError,
  ]);

  // Lifecycle | Check for update | User AIO API Response
  useEffect(() => {
    if (getUserAioFetching || getUserAioLoading) {
    } else if (getUserAioSuccess) {
      if (getUserAioData?.status === 1) {
        if (getUserAioData?.data?.modules?.levelling_enabled) {
          // REMEMBER: Remove after TW is available for premium
          if (!i18n.language.toLowerCase().includes("zh-tw")) {
            getLevellingTasks();
          }
        }

        dispatch(
          updateOwnPrivateCallEnable(
            getUserAioData?.data?.private_call_settings
              ?.system_private_calls_enabled &&
              getUserAioData?.data?.private_call_settings?.enable_calls
          )
        );
      } else {
      }
    } else if (getUserAioError) {
      if (getUserAioErrorData?.status === 401) {
        onNavigate(routeConst.logout.path);
      }
    }
  }, [
    getUserAioFetching,
    getUserAioLoading,
    getUserAioSuccess,
    getUserAioError,
  ]);

  // Lifecycle | Check for update | Private Call Free Minutes API Response
  useEffect(() => {
    if (getPrivateCallFreeMinutesFetching || getPrivateCallFreeMinutesLoading) {
    } else if (getPrivateCallFreeMinutesSuccess) {
    } else if (getPrivateCallFreeMinutesError) {
      if (getPrivateCallFreeMinutesErrorData?.status === 401) {
        onNavigate(routeConst.logout.path);
      }
    }
  }, [
    getPrivateCallFreeMinutesFetching,
    getPrivateCallFreeMinutesLoading,
    getPrivateCallFreeMinutesSuccess,
    getPrivateCallFreeMinutesError,
  ]);

  // Lifecycle | Check for update | Levelling Tasks API Response
  useEffect(() => {
    if (getLevellingTasksFetching || getLevellingTasksLoading) {
    } else if (getLevellingTasksSuccess) {
      if (getLevellingTasksData?.status === 0) {
        const levellingTasks = getLevellingTasksData?.data?.tasks;

        if (levellingTasks) {
          const dailyCheckInTask = levellingTasks.find(
            (task) => task.task_id === 3
          );

          if (dailyCheckInTask) {
            // Set Daily Check In Timer
            const endDateSeconds = dailyCheckInTask.date_end_epoch;
            const currentTime = moment().unix();
            dispatch(setDailyCheckInTimer(endDateSeconds - currentTime));

            if (!dailyCheckInInterval) {
              dispatch(
                updateDailyCheckInInterval(
                  setInterval(() => {
                    dispatch(updateDailyCheckInTimer());
                  }, 1000)
                )
              );
            }

            // Check if "daily-check-in" in local storage is true or false
            if (
              i18n.language.toLowerCase().includes("zh-tw") === false &&
              !sessionService.getDailyCheckIn() &&
              !dailyCheckInTask.claimed
            ) {
              dispatch(updateDailyCheckInDialog(true));
              sessionService.setDailyCheckIn(true);
            }
          }
        }
      }
    } else if (getLevellingTasksError) {
      if (getLevellingTasksErrorData?.status === 401) {
        onNavigate(routeConst.logout.path);
      }
    }
  }, [
    getLevellingTasksFetching,
    getLevellingTasksLoading,
    getLevellingTasksSuccess,
    getLevellingTasksError,
  ]);

  // Lifecycle | Check for update | Livestreaming Contest List API Response
  useEffect(() => {
    if (
      getLivestreamingContestListFetching ||
      getLivestreamingContestListLoading
    ) {
    } else if (getLivestreamingContestListSuccess) {
      if (getLivestreamingContestListData?.status === 1) {
        const results = getLivestreamingContestListData?.data?.results ?? [];
        const pkList = [];

        for (let i = 0; i < results?.length; i++) {
          if (results[i]?.contest_type === "single") {
            dispatch(updateLivestreamingContestId(results[0]?.contest_id));
          }

          if (results[i]?.contest_type === "pk") {
            pkList.push(results[i]);
          }
        }

        if (pkList?.length > 0) {
          dispatch(updateLivestreamingContestPkId(pkList[0]?.contest_id));
        }
        dispatch(updateLivestreamingContestPkList(pkList));
      }
    } else if (getLivestreamingContestListError) {
      if (getLivestreamingContestListErrorData?.status === 401) {
        onNavigate(routeConst.logout.path);
      }
    }
  }, [
    getLivestreamingContestListFetching,
    getLivestreamingContestListLoading,
    getLivestreamingContestListSuccess,
    getLivestreamingContestListError,
  ]);

  // Lifecycle | Check for update | Private Call Contest List API Response
  useEffect(() => {
    if (getPrivateCallContestListFetching || getPrivateCallContestListLoading) {
    } else if (getPrivateCallContestListSuccess) {
      if (getPrivateCallContestListData?.status === 0) {
        if (getPrivateCallContestListData?.data?.results) {
          dispatch(
            updatePrivateCallContestId(
              getPrivateCallContestListData?.data?.results[0]?.contest_id
            )
          );
        }
      }
    } else if (getPrivateCallContestListError) {
      if (getPrivateCallContestListErrorData?.status === 401) {
        onNavigate(routeConst.logout.path);
      }
    }
  }, [
    getPrivateCallContestListFetching,
    getPrivateCallContestListLoading,
    getPrivateCallContestListSuccess,
    getPrivateCallContestListError,
  ]);

  // Lifecycle | Check for update | Initiate Email Verification API Response
  useEffect(() => {
    if (initiateEmailVerificationLoading) {
    } else if (initiateEmailVerificationSuccess) {
      switch (initiateEmailVerificationData?.status) {
        case 1:
          const createdAt =
            initiateEmailVerificationData?.data?.email_verification?.created_at;
          const expiredAt =
            initiateEmailVerificationData?.data?.email_verification?.expired_at;
          const diffInSeconds = moment(expiredAt).diff(createdAt, "seconds");
          dispatch(setEmailVerificationTimer(60));
          onNavigate(routeConst.verify.emailVerification.altPath);
          break;
        case -1:
          // Need to wait 3 minutes
          const errorToast = {
            message: initiateEmailVerificationData?.message,
            autoClose: 3000,
          };
          dispatch(updateErrorToast(errorToast));
          onNavigate(routeConst.verify.emailVerification.altPath);
          break;
        default:
          // Not sure
          break;
      }
    } else if (initiateEmailVerificationError) {
      switch (initiateEmailVerificationErrorData?.data?.status) {
        case -1:
          // There is pending verification request, please request again awhile later
          const errorToast = {
            message: initiateEmailVerificationErrorData?.data?.message,
            autoClose: 3000,
          };
          dispatch(updateErrorToast(errorToast));
          onNavigate(routeConst.verify.emailVerification.altPath);
          break;
        default:
          break;
      }
    }
  }, [
    initiateEmailVerificationLoading,
    initiateEmailVerificationSuccess,
    initiateEmailVerificationError,
  ]);

  // Lifecycle | Check for update | Notifications Count API Response
  useEffect(() => {
    if (getNotificationsCountFetching || getNotificationsCountLoading) {
    } else if (getNotificationsCountSuccess) {
      switch (getNotificationsCountData?.status) {
        case 0:
          dispatch(updateNotificationCountLoaded(true));
          dispatch(
            updateNotificationCount(getNotificationsCountData?.data?.unseen)
          );

          setTimeout(() => {
            dispatch(updateShowNotificationBadge());
          }, 1000);
          break;
        default:
          break;
      }
    } else if (getNotificationsCountError) {
    }
  }, [
    getNotificationsCountFetching,
    getNotificationsCountLoading,
    getNotificationsCountSuccess,
    getNotificationsCountError,
  ]);

  // Lifecycle | Check for update | Journey API Response
  useEffect(() => {
    if (getJourneyFetching || getJourneyLoading) {
    } else if (getJourneySuccess) {
      // Build a function to determine which page to navigate to
      // This API will be used to determine email and mobile verification too

      if (getJourneyData?.user_journey) {
        if (!hasLoaded) {
          setHasLoaded(true);

          // Save the state of email and mobile verification required
          // Used for checking if email and mobile verification is skippable
          dispatch(
            updateEmailVerificationDisplay(
              getJourneyData?.user_journey?.email_verification?.required
            )
          );
          dispatch(
            updateMobileVerificationDisplay(
              getJourneyData?.user_journey?.mobile_verification?.required
            )
          );
        }
        dispatch(updateLastLocation(location.pathname));
        dispatch(
          updateSkippableJourney(!getJourneyData?.user_journey?.restarted)
        );
        dispatch(updateJourneyDataPassthrough(getJourneyData));
        dispatch(updateJourneyNavigationPassthrough({}));
      }
    } else if (getJourneyError) {
    }
  }, [
    getJourneyFetching,
    getJourneyLoading,
    getJourneySuccess,
    getJourneyError,
  ]);

  // Lifecycle | Check for update | dailyCheckInTimer
  useEffect(() => {
    if (!isLoggedIn || !dailyCheckInTimer) return;

    // After reaching endDate, will clean up Daily Check In variables & recall Levelling Task API
    if (dailyCheckInTimer <= 0) {
      dispatch(clearDailyCheckInInterval());
      dispatch(resetDailyCheckInTimer());
      sessionService.deleteDailyCheckIn(false);
      getLevellingTasks();
    }
  }, [isLoggedIn, dailyCheckInTimer]);

  // Lifecycle | Check for update | getAioSuccess & getProfileSuccess
  useEffect(() => {
    if (getUserAioSuccess && getProfileSuccess) {
      if (getUserAioData?.data?.modules?.zendesk_chatbot_enabled) {
        initKommunicate(
          getProfileData?.data?.id_int,
          getProfileData?.data?.username,
          getProfileData?.data?.email
        );
      }
    }
  }, [getUserAioSuccess, getProfileSuccess]);

  // Utility Functions
  const generalVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      // When user goes out and in the page, AIO API will be called again to detect VPN
      getAio(null, false);
    }
  };
  const loggedInVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      getUserAio("?mounted=true", false);
      getProfile("?mounted=true", false);
    }
  };
  const initKommunicate = (userId, userName, email) => {
    // Kommunicate
    Kommunicate.init(process.env["REACT_APP_KOMMUNICATE_APP_ID"], {
      automaticChatOpenOnNavigation: true,
      userId,
      userName,
      email,
      widgetSettings: {
        preCreateUser: true,
      },
      customLabelLocales: {
        zh: {
          "input.message": "請輸入你的訊息",
          "conversations.title": "對話",
          "start.new": "提交問題",
          online: "在線上",
          "time.format.AM": "上午",
          "time.format.PM": "下午",
          hour: "小時",
          min: "分鐘",
          yesterday: "昨天",
          hours: "小時",
          mins: "分",
          ago: "前",
          "time.stamp.sec.ago": "秒前",
          "time.stamp.secs.ago": "秒前",
          "time.stamp.min.ago": "分鐘前",
          "time.stamp.mins.ago": "分鐘前",
          "time.stamp.hr.ago": "小時前",
          "time.stamp.hrs.ago": "小時前",
        },
      },
      onInit: function () {
        console.log("Kommunicate initialized");
        var css1 =
          ".mck-file-upload { display: none !important; } #km-widget-options { visibility: hidden; } .mck-powered-by { pointer-events: none !important } #applozic-badge-count { display: none !important; } #mck-sidebox-launcher { display: none; }";
        window?.Kommunicate?.customizeWidgetCss(css1);
        window?.Kommunicate?.displayKommunicateWidget(false);

        dispatch(updateIsKommunicateInitialized(true));
      },
    });
  };

  return <div id="app-mounted-shadow-component"></div>;
};

export default ApiMounted;
